import { useMemo } from 'react';

export type TrustpilotRating =
  | 'Bad'
  | 'Poor'
  | 'Average'
  | 'Great'
  | 'Excellent';

export interface TrustpilotBarHook {
  reviews: number;
  stars: number;
  rating: TrustpilotRating;
  className: string;
}

export default function useTrustpilotBar(
  wrapperClassName: string,
): TrustpilotBarHook {
  const className = useMemo(
    () => `w-full flex ${wrapperClassName}`,
    [wrapperClassName],
  );

  return {
    reviews: 752,
    stars: 4.5,
    rating: 'Excellent',
    className,
  };
}
